import React, { useState } from 'react';
import { MapPin, Package, Calculator, Truck } from 'lucide-react';
import { motion } from 'framer-motion';
export function LogisticsCalculator() {
  const [location, setLocation] = useState('');
  const [weight, setWeight] = useState('');
  const [cost, setCost] = useState<number | null>(null);
  const calculateShipping = () => {
    if (!location || !weight) return;
    // Mock calculation logic
    const baseRate = 1500;
    const weightRate = Number(weight) * 500;
    const randomFactor = Math.floor(Math.random() * 1000);
    setCost(baseRate + weightRate + randomFactor);
  };
  return <section className="py-20 bg-[#0a0a0a] relative overflow-hidden" data-id="element-132">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-20 pointer-events-none" data-id="element-133">
        <div className="absolute -right-20 top-20 w-96 h-96 bg-[#00FF87] rounded-full mix-blend-screen filter blur-[100px]" data-id="element-134" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-135">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-136">
          {/* Text Content */}
          <div data-id="element-137">
            <h2 className="text-3xl md:text-4xl font-bold font-serif text-white mb-6" data-id="element-138">
              Smart Logistics <br data-id="element-139" />
              <span className="text-[#00FF87]" data-id="element-140">Calculator</span>
            </h2>
            <p className="text-gray-400 text-lg mb-8" data-id="element-141">
              Planning a delivery? Get an instant estimate for shipping anywhere
              in Nigeria. We partner with top logistics providers to ensure your
              package arrives safely and on time.
            </p>

            <ul className="space-y-4" data-id="element-142">
              {['Real-time tracking for all packages', 'Insurance coverage up to ₦500,000', 'Same-day delivery in Lagos & Abuja', 'Nationwide coverage across 36 states'].map((item, i) => <li key={i} className="flex items-center gap-3 text-gray-300" data-id="element-143">
                  <div className="w-2 h-2 rounded-full bg-[#00FF87]" data-id="element-144" />
                  {item}
                </li>)}
            </ul>
          </div>

          {/* Calculator Card */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="glass-panel p-8 rounded-2xl border border-white/10" data-id="element-145">
            <div className="flex items-center gap-3 mb-8" data-id="element-146">
              <div className="p-3 bg-[#00FF87]/10 rounded-lg text-[#00FF87]" data-id="element-147">
                <Truck className="w-6 h-6" data-id="element-148" />
              </div>
              <h3 className="text-xl font-bold text-white" data-id="element-149">
                Shipping Estimator
              </h3>
            </div>

            <div className="space-y-6" data-id="element-150">
              <div data-id="element-151">
                <label className="block text-sm font-medium text-gray-400 mb-2" data-id="element-152">
                  Destination State
                </label>
                <div className="relative" data-id="element-153">
                  <MapPin className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-500 w-5 h-5" data-id="element-154" />
                  <select value={location} onChange={e => setLocation(e.target.value)} className="w-full bg-white/5 border border-white/10 rounded-lg py-3 pl-12 pr-4 text-white focus:outline-none focus:border-[#00FF87] focus:ring-1 focus:ring-[#00FF87] appearance-none" data-id="element-155">
                    <option value="" disabled data-id="element-156">
                      Select State
                    </option>
                    <option value="Lagos" data-id="element-157">Lagos</option>
                    <option value="Abuja" data-id="element-158">Abuja</option>
                    <option value="Rivers" data-id="element-159">Rivers</option>
                    <option value="Kano" data-id="element-160">Kano</option>
                    <option value="Oyo" data-id="element-161">Oyo</option>
                  </select>
                </div>
              </div>

              <div data-id="element-162">
                <label className="block text-sm font-medium text-gray-400 mb-2" data-id="element-163">
                  Package Weight (kg)
                </label>
                <div className="relative" data-id="element-164">
                  <Package className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-500 w-5 h-5" data-id="element-165" />
                  <input type="number" placeholder="0.0" value={weight} onChange={e => setWeight(e.target.value)} className="w-full bg-white/5 border border-white/10 rounded-lg py-3 pl-12 pr-4 text-white focus:outline-none focus:border-[#00FF87] focus:ring-1 focus:ring-[#00FF87]" data-id="element-166" />
                </div>
              </div>

              <button onClick={calculateShipping} className="w-full bg-[#00FF87] text-black font-bold py-4 rounded-lg hover:bg-[#00cc6a] transition-colors flex items-center justify-center gap-2" data-id="element-167">
                <Calculator className="w-5 h-5" data-id="element-168" />
                Calculate Cost
              </button>

              {cost !== null && <motion.div initial={{
              opacity: 0,
              y: 10
            }} animate={{
              opacity: 1,
              y: 0
            }} className="mt-6 p-4 bg-white/5 rounded-lg border border-[#00FF87]/30 text-center" data-id="element-169">
                  <p className="text-gray-400 text-sm mb-1" data-id="element-170">
                    Estimated Shipping Cost
                  </p>
                  <p className="text-2xl font-bold text-white" data-id="element-171">
                    {new Intl.NumberFormat('en-NG', {
                  style: 'currency',
                  currency: 'NGN'
                }).format(cost)}
                  </p>
                </motion.div>}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}